
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/open-resorts",
      function () {
        return require("private-next-pages/[region]/open-resorts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/open-resorts"])
      });
    }
  